import React, { useState } from "react";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
  Table,
  ButtonGroup,
} from "reactstrap";
import { NumericFormat } from "react-number-format";

const SidebarVoucher = ({
  isOpen,
  toggle,
  voucherAtual,
  loading,
  campanhas,
  parceiros,
  getStatusBadge,
  onIncreaseQuantity,
  onDecreaseQuantity,
}) => {
  const [operacao, setOperacao] = useState('increase');
  const [quantidade, setQuantidade] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    const quantidadeNum = parseInt(quantidade);
    
    if (operacao === 'increase') {
      onIncreaseQuantity(quantidadeNum);
    } else {
      onDecreaseQuantity(quantidadeNum);
    }
  };

  const handleOperacaoChange = (op) => {
    setOperacao(op);
    setQuantidade('');
  };

  return (
    <Offcanvas isOpen={isOpen} toggle={toggle} direction="end" className="w-50">
      <OffcanvasHeader toggle={toggle}>
        <span className="fw-semibold">Editar Voucher</span>
      </OffcanvasHeader>
      <OffcanvasBody>
        {voucherAtual && (
          <>
            <div className="mb-4">
              <h6 className="fw-medium mb-3">Informações do Voucher</h6>
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-2">
                    <small className="text-muted d-block">Código</small>
                    <div className="fw-medium">{voucherAtual.codigo}</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-2">
                    <small className="text-muted d-block">Campanha</small>
                    <div className="fw-medium">
                      {campanhas.find((c) => c.id === voucherAtual.campanha_id)?.nome || "-"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-2">
                    <small className="text-muted d-block">Parceiro</small>
                    <div className="fw-medium">
                      {parceiros.find((p) => p.id === voucherAtual.parceiro_id)?.nome || "-"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-2">
                    <small className="text-muted d-block">Status</small>
                    <div>{getStatusBadge(voucherAtual)}</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-2">
                    <small className="text-muted d-block">Quantidade Disponível</small>
                    <div className="fw-medium">{voucherAtual.quantidade}</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-2">
                    <small className="text-muted d-block">Quantidade Total</small>
                    <div className="fw-medium">{voucherAtual.quantidade_original}</div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-2">
                    <small className="text-muted d-block">Valor</small>
                    <div className="fw-medium">
                      {voucherAtual.valor ? `R$ ${parseFloat(voucherAtual.valor).toFixed(2)}` : "-"}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Form onSubmit={handleSubmit}>
              <div className="mb-3">
                <Label className="fw-medium mb-2">Operação</Label>
                <div>
                  <ButtonGroup>
                    <Button
                      color={operacao === 'increase' ? 'info' : 'light'}
                      onClick={() => handleOperacaoChange('increase')}
                      type="button"
                    >
                      Aumentar Quantidade
                    </Button>
                    <Button
                      color={operacao === 'decrease' ? 'danger' : 'light'}
                      onClick={() => handleOperacaoChange('decrease')}
                      type="button"
                    >
                      Diminuir Quantidade
                    </Button>
                  </ButtonGroup>
                </div>
              </div>

              <FormGroup>
                <Label for="quantidade" className="fw-medium">
                  {operacao === 'increase' ? 'Quantidade a Aumentar' : 'Quantidade a Diminuir'} <span className="text-danger">*</span>
                </Label>
                <Input
                  id="quantidade"
                  name="quantidade"
                  type="number"
                  value={quantidade}
                  onChange={(e) => setQuantidade(e.target.value)}
                  required
                  min="1"
                  placeholder="Ex: 50"
                />
                <small className="text-muted">
                  {operacao === 'increase' 
                    ? 'A quantidade será adicionada ao total atual'
                    : 'A quantidade será subtraída do total atual. Não pode resultar em um número menor que os vouchers já utilizados.'}
                </small>
              </FormGroup>

              <Button type="submit" color={operacao === "increase" ? "info" : "danger"} className="mt-3" disabled={loading}>
                {loading && <Spinner size="sm" className="me-2" />}
                {operacao === 'increase' ? 'Aumentar' : 'Diminuir'} Quantidade
              </Button>
            </Form>

            <div className="mt-4">
              <h6 className="fw-medium mb-3">Clientes que Utilizaram (Total: {voucherAtual.clientes?.length})</h6>
              {voucherAtual.clientes?.length > 0 ? (
                <div className="table-responsive">
                  <Table className="table-nowrap mb-0">
                    <thead className="table-light">
                      <tr>
                        <th>Nome</th>
                        <th>Email</th>
                        <th>Data de Uso</th>
                      </tr>
                    </thead>
                    <tbody>
                      {voucherAtual.clientes.map((cliente) => (
                        <tr key={cliente.id}>
                          <td>{cliente.nome_completo}</td>
                          <td>{cliente.email}</td>
                          <td>
                            {new Date(cliente.pivot.created_at).toLocaleDateString()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              ) : (
                <div className="text-center py-4 text-muted">
                  Nenhum cliente utilizou este voucher ainda
                </div>
              )}
            </div>
          </>
        )}
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default SidebarVoucher; 